import { render } from "./AuthModal.vue?vue&type=template&id=7a18b675&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"

import "./AuthModal.vue?vue&type=style&index=0&id=7a18b675&scoped=true&lang=css"

import exportComponent from "/home/alex/Work/Projects/gominigames/web/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a18b675"]])

export default __exports__